import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Page } from '../components'
import { WKVisible } from '../components/wk'
import '../css/page/MessagePage.css'
import { Tab, NewSystem, My } from '../components/message'
import { fixBackContentEmpty, getAccessToken, isLZWKAPP } from '../utils'


class MessagePage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            systemMsgs: null,
            myMsgs: null,
            system_has_more: true,
            system_offset_id: 0,
        }
    }
    componentDidMount() {
        fixBackContentEmpty()
        document.title = '我的消息'
        this.props.dispatch({
            type: 'WK_INIT_BOTTOM_BAR',
            payload: {
                selectType: 'consult',
                consultCount: 0,
            }
        })
        !isLZWKAPP() && this.fetchMyMsgs()
        this.fetchSystemMsgs()
        const that = this
        window.onscroll = function () {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            if (scrollTop + windowHeight >= scrollHeight) {   //考虑到滚动的位置一般可能会大于一点可滚动的高度，所以这里不能用等于
                that.props.tabId === 1 && that.fetchSystemMsgs()
            }
        }
    }
    fetchMyMsgs() {
        let access_token = getAccessToken()
        window.axiosMsg.get(`/msg/list`, {
            params: {
                token: access_token,
                t: new Date().getTime(),
            }
        }).then(res => {
            const { message_list: myMsgs } = res.data.data
            this.setState({
                myMsgs
            })
        })
    }
    fetchSystemMsgs() {
        if (!this.state.system_has_more) return
        axios.get('/api/messages/message/my', {
            params: {
                t: new Date().getTime(),
                offset_id: this.state.system_offset_id
            }
        }).then(res => {
            const { messages: systemMsgs, has_more: system_has_more } = res.data.data
            this.setState({
                systemMsgs: this.state.system_offset_id === 0 ? systemMsgs : this.state.systemMsgs.concat(systemMsgs),
                system_has_more,
                system_offset_id: systemMsgs.length > 0 ? systemMsgs[systemMsgs.length - 1].id : 0,
            })
        })
    }

    render() {
        return (
            <Page>
                <div className="wk-inner-page message-page" style={{ paddingTop: isLZWKAPP() ? 0 : '55px' }}>
                    <WKVisible create={!isLZWKAPP()}>
                        <Tab routeTab={this.props.params.tab} myMsgs={this.state.myMsgs} />
                    </WKVisible>
                    <NewSystem systemMsgs={this.state.systemMsgs} tabId={this.props.tabId} hasMore={this.state.system_has_more} />
                    <WKVisible create={!isLZWKAPP()}>
                        <My myMsgs={this.state.myMsgs} tabId={this.props.tabId} />
                    </WKVisible>
                </div>
            </Page>
        )
    }
}


export default connect(state => ({
    tabId: state.component.wkTab.selectId,
    account: state.account,
}))(MessagePage)



// WEBPACK FOOTER //
// ./src/pages/MessagePage.js